import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpService } from '@services/http.service';
import { WebPage } from '@models/webpage/webpage';
import { EndpointParams } from '@models/utils/endpoint-params';

@Injectable({
    providedIn: 'root'
})
export class CenterService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'center', version: 1 };

    getWebPage(domain: string): Observable<WebPage> {
        return this.get(`polaris/webpage/domain/${domain}`, this.defaultEndpointParams);
    }

    info(domain: string): Observable<any> {
        return this.get(`public/center/${domain}`, this.defaultEndpointParams);
    }

    sendLoginAccess(): Observable<any> {
        return this.post('polaris/webpage/send/login', this.defaultEndpointParams);
    }
}
